
//Teams themes
export const teamsThemes = {
  DEFAULT: 'default',
  DARK: 'dark',
}

//Teams page contexts
export const teamsPageContexts = {
  TAB: 'tab',
  TASK: 'task',
  CONTENT: 'content',
}

//Teams app versions
export const teamsAppVersions = {
  V2: 2,
  V3: 3,
}

//Teams V2 app ID's
export const teamsAppIdsV2 = {
  PRODUCTION: '23ec340e-6da6-42d5-a879-0983135bf0c1',
  QA: 'dd6d6fd1-ddfd-4686-a67c-a38d42e79c82',
  SIDELOADED_4VFMP0_TENANT: 'cd187f57-522d-41f4-8438-e6ea78e57a26',
}

//Teams V3 app ID's
export const teamsAppIdsV3 = {
  PRODUCTION: 'a275d93b-56eb-4362-afd4-4ab8b115c6c6',
  STAGING: '785b8db7-fd7d-4a8b-8831-a8dcaf961379',
  QA: '9d781263-bd78-4a6b-b4e0-662ff07ba624',
  DEV: '4c125d22-0b52-4dec-a0c8-37770e0e3511',
}
